import Phaser from 'phaser';
import { GAME } from '../config';

export function showPauseOverlay(scene: Phaser.Scene, onResume: () => void, onQuit: () => void): Phaser.GameObjects.Container {
  const container = scene.add.container(0, 0).setDepth(100);

  // Semi-transparent overlay
  const bg = scene.add.rectangle(GAME.width / 2, GAME.height / 2, GAME.width, GAME.height, 0x000000, 0.6);
  bg.setInteractive();  // absorb clicks
  container.add(bg);

  // Title
  const title = scene.add.text(GAME.width / 2, GAME.height / 2 - 80, '⏸ 暫停', {
    fontSize: '48px', color: '#fff', fontFamily: 'sans-serif',
  }).setOrigin(0.5);
  container.add(title);

  // Resume button
  const resumeBg = scene.add.rectangle(GAME.width / 2, GAME.height / 2 + 10, 200, 50, 0x4caf50).setInteractive();
  const resumeText = scene.add.text(GAME.width / 2, GAME.height / 2 + 10, '繼續', { fontSize: '24px', color: '#fff' }).setOrigin(0.5);
  container.add([resumeBg, resumeText]);
  resumeBg.on('pointerup', () => { container.destroy(); onResume(); });

  // Quit button
  const quitBg = scene.add.rectangle(GAME.width / 2, GAME.height / 2 + 80, 200, 50, 0xef5350).setInteractive();
  const quitText = scene.add.text(GAME.width / 2, GAME.height / 2 + 80, '離開', { fontSize: '24px', color: '#fff' }).setOrigin(0.5);
  container.add([quitBg, quitText]);
  quitBg.on('pointerup', () => { container.destroy(); onQuit(); });

  return container;
}
